if (!customElements.get('country-overlay-form')) {
	customElements.define(
		'country-overlay-form',
		class CountryOverlayForm extends HTMLElement {
			constructor() {
				super();
				this.elements = {
					closeInput: this.querySelector('.country-overlay-form__inner--close-btn'),
					input: this.querySelector('input[name="country_code"]'),
					langInput: this.querySelector('input[name="locale_code"]'),
					currMarket: document.querySelector('html').getAttribute('market'),
					restOfWorldInput: this.querySelector('.rest-of-world__placeholder')
				};

				this.elements.closeInput.addEventListener('click', (e) => this.closeOverlay(e));
				this.addEventListener('click', (e) => this.closeOverlay(e));
				if (this.elements.restOfWorldInput) {
					this.elements.restOfWorldInput.addEventListener('click', (e) => this.closeOverlay(e, true));
				}

				this.querySelectorAll('a.disclosure__link').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
				if (this.elements.currMarket === 'xk' && localStorage.getItem("witt-market-popup-shown") === null || this.elements.currMarket === 'xk' && localStorage.getItem("witt-market-popup-shown") === null) this.openOverlay();

			}

			closeOverlay(e, closeAutomatically) {
				if (e.target.classList.contains('country-overlay-form__inner--close-btn') || e.target === this || closeAutomatically) {
					this.classList.add('hidden');
					document.querySelector('html').classList.remove('no-scroll');
					localStorage.setItem('witt-market-popup-shown', true);
					localStorage.setItem('witt-market-locale', '');
				}

			}

			setMarketPopupCookies(name, value, minutes) {
				return document.cookie = `${name}=${value}; max-age=${minutes * 60}; path=/`;
			}
			getCookie(name) {
				return document.cookie?.split('; ').find(row => row.startsWith(name))?.split('=')[1];
			}

			openOverlay() {
				this.removeSpecificCountriesFromOverlay();
				this.classList.remove('hidden');
				document.querySelector('html').classList.add('no-scroll');
			}

			removeSpecificCountriesFromOverlay() {
				const kosovoEl = this.querySelector('a[data-value="XK"]');
				if (kosovoEl) kosovoEl.remove();
			}


			onItemClick(event) {
				event.preventDefault();
				const form = this.querySelector('form');
				this.elements.langInput.value = event.currentTarget.dataset.lang;
				this.elements.input.value = event.currentTarget.dataset.value;
				localStorage.setItem('witt-market-popup-shown', true);
				localStorage.setItem('witt-market-locale', `${event.currentTarget.dataset.lang}-${event.currentTarget.dataset.value}`);
				if (form) form.submit();
			}
		}
	);
}
